import { inject, Injectable } from '@angular/core';
import { TOKEN_STORAGE } from '../storage/token-storage';
import { TokenInterface } from 'app-old-buyer/interfaces/auth.operations.interface';

@Injectable({
    providedIn: 'root',
})
export class TokenStorageService {
    readonly #tokenStorage = inject(TOKEN_STORAGE);
    readonly #storageKey = 'authToken';
    readonly #refreshTokenKey = 'refreshToken';

    setToken(token: string): void {
        this.#tokenStorage.setItem(this.#storageKey, token);
    }

    getToken(): string | null {
        return this.#tokenStorage.getItem(this.#storageKey);
    }

    removeToken(): void {
        this.#tokenStorage.removeItem(this.#storageKey);
    }

    hasToken(): boolean {
        return !!this.#tokenStorage.getItem(this.#storageKey);
    }

    setRefreshToken(token: string): void {
        this.#tokenStorage.setItem(this.#refreshTokenKey, token);
    }

    getRefreshToken(): string | null {
        return this.#tokenStorage.getItem(this.#refreshTokenKey);
    }

    removeRefreshToken(): void {
        this.#tokenStorage.removeItem(this.#refreshTokenKey);
    }

    hasRefreshToken(): boolean {
        return !!this.#tokenStorage.getItem(this.#refreshTokenKey);
    }

    decodeToken(newToken?: string): TokenInterface | null {
        const token = this.getToken() || newToken;
        if (!token) return null;
        try {
            return JSON.parse(atob(token.split('.')[1])) as TokenInterface;
        }
        catch (error) {
            console.error('Erro ao decodificar o token:', error);
            return null;
        }
    }

    isTokenValid(): boolean {
        const decodedToken = this.decodeToken();
        if (!decodedToken) return false;
        const expirationTime = decodedToken.exp;
        const currentTime = Math.floor(Date.now() / 1000);
        return expirationTime ? expirationTime > currentTime : true;
    }
}
